import { resolveUrl } from "../../../../utils/url/urlResolver";
import { type QuoteDetailsDTO } from "./dto";

// soNumber === salesDocument
export async function fetchQuoteDetails(
  soNumber: string,
  accountNumber?: string,
  salesOrg?: string
): Promise<QuoteDetailsDTO> {
  let url = resolveUrl(`/my-account/quotes/detail/${soNumber}`);

  if (accountNumber && salesOrg) {
    const params = new URLSearchParams();
    params.append("account", accountNumber);
    params.append("salesOrg", salesOrg);
    url = url + "?" + params.toString();
  }

  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  return (await response.json()) as QuoteDetailsDTO;
}
